import React, { useState } from 'react';
import StarRating from './StarRating';
import { api } from '../services/api';
import StepDrawer from './StepDrawer';

function ReviewUpdateForm({
  toast,
  id,
  formData,
  setFormData,
  onBack,
  surgery,
  onCancel,
  currentStep,
  totalSteps
}) {
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    setError(null);
    setSubmitting(true);
    if (id) {
      api.editUpdate(id, { ...formData })
        .then(() => {
          toast('Successfully updated')
          onCancel()
        }).finally(() => {
          setSubmitting(false);
        })
    } else {
      try {
        await api.createReviewUpdate({
          ...formData,
          id: Number(surgery)
        })
        toast('Surgeries Updated!');
        onCancel();
      } catch (err) {
        setError(err.message || 'Failed to submit update');
      } finally {
        setSubmitting(false);
      }
    }
  };

  const setDescription = (description) => {
    setFormData(prev => ({ ...prev, description }))
  }



  return (
    <StepDrawer
      currentStep={currentStep}
      totalSteps={totalSteps}
      onCancel={onCancel}
      onContinue={handleSubmit}
      disabled={submitting}
      onBack={onBack}
      title={
        <span>Additional Details <span style={{ color: '#9BA3AF' }}>(Optional)</span></span>
    }
    >
      <div className="form-content scrollable review-update-form-content">

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>

          <div className="review-row-large">
            <div className="review-label">
              Additional details:
            </div>
            <textarea
              className="review-value"
              value={formData.description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="What else has changed since you last posted on this surgery..."
              required
            />
          </div>
        </form>
      </div>
    </StepDrawer>
  );
}

export default ReviewUpdateForm; 